import React from 'react';
import styled from "styled-components";
import LoaderIcon from "../../../assets/images/loader.svg";

class Loader extends React.Component{
    render(){
        return(<LoaderWrapper> 
        <div className="loader">
        <img src={LoaderIcon} alt="" />
      </div>
      </LoaderWrapper> )
    }
  

}
export default Loader;

const LoaderWrapper = styled.div`
.loader {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  `;


// WEBPACK FOOTER //
// ./src/app/components/loader/loader.js